// extracted by mini-css-extract-plugin
module.exports = {"spaceAround":"flex-space-around_spaceAround__14_DE"};